import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
export var getInitials = function getInitials(firstName, lastName) {
  return (firstName ? firstName.charAt(0) : '') + (lastName ? lastName.charAt(0) : '');
};
export var joinNames = function joinNames(names) {
  return names === null || names === void 0 ? void 0 : names.filter(function (value) {
    return !!value;
  }).join(' ');
};